import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { TranslationService } from '@services/translation.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { SignalService } from '@services/signals.service';
import { environment } from '@environments/environment';
import { DToast } from '@components/d-toast/d-toast';

@Component({
	selector: 'app-root',
	imports: [
		RouterOutlet,
		DToast,
		ConfirmDialogModule,
		ConfirmPopupModule,
		TranslatePipe,
	],
	templateUrl: './app.html',
})
export class App {
	protected readonly title = signal('command-center');
	private signalService = inject(SignalService);


	constructor(
		private translationService: TranslationService,
		private translateService: TranslateService
	) {
		this.translationService.setTranslateFn(
			this.translateService.instant.bind(this.translateService)
		);
		this.signalService.setSignal('BASE_SERVICE', environment.baseService);
		this.signalService.setSignal('APP_ENVIRONMENT', environment.appEnvironment);
	}
}
